import { apiFactory } from "../api_factory";

export const assessmentSummariesApi = apiFactory({
  path: "/api/v4/assessment-summaries",
  useGetOverride: true
});
